import React, { ReactNode } from 'react';
import LazyImage from '@/components/LazyImage';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface LeaderboardHeaderProps {
  img?: string;
  title: ReactNode;
  subtitle?: string;
  variant?: 'compact' | 'full';
}

export const LeaderboardHeader: React.FC<LeaderboardHeaderProps> = ({
  img,
  title,
  subtitle,
  variant = 'full'
}) => {
  const titleClass = variant === 'full' ? 'text-20' : '';

  return (
    <div className="d-flex align-items-center g-20">
      {img && (
        <LazyImage
          className={classNames(styles.media, { [styles.compact]: variant !== 'full' })}
          src={img}
          alt="league"
        />
      )}
      <div className="d-flex flex-column g-4">
        {variant === 'full' ? (
          <h2 className={titleClass}>{title}</h2>
        ) : (
          <h3 className={titleClass}>{title}</h3>
        )}
        {(subtitle && variant === 'full') && <span className="text-12">{subtitle}</span>}
      </div>
    </div>
  );
};

export default LeaderboardHeader;
